import { t, Trans } from "@lingui/macro";
import { Box, Button } from "@mui/material";
import { AutoSelectTextField, SlidingDrawer } from "@WahooFitness/redesignr";
import { useConfigContext } from "@WahooFitness/wahoo-offline-mfe";

interface AddCustomPageDrawerProps {
  open: boolean;
  pageName: string;
  handleCancel: () => void;
  handleSave: (pageName: string) => void;
  handleOnChange: (value: string) => void;
  maxPageNameLength: number;
}

const AddCustomPageDrawer: React.FC<AddCustomPageDrawerProps> = ({
  pageName,
  handleCancel,
  handleSave,
  handleOnChange,
  maxPageNameLength,
  open,
}: AddCustomPageDrawerProps) => {
  const { globalBottomPadding, platform } = useConfigContext();

  return (
    <SlidingDrawer
      platform={platform}
      globalBottomPadding={globalBottomPadding}
      open={open}
      title={t`Add workout page`}
      hidePuller
      hideDivider
      elevation={4}
      handleOpen={() => {}}
      handleClose={handleCancel}
    >
      <Box display="flex" gap={2} p={3} flexDirection="column">
        <AutoSelectTextField
          fullWidth
          variant="outlined"
          label={t`Page name`}
          value={pageName}
          onChange={(e) => handleOnChange(e.target.value)}
          inputProps={{ maxLength: maxPageNameLength }}
          onContextMenu={(event) => event.preventDefault()}
          autoFocus
        />

        <Box display="flex" flexDirection="row" gap={1.5} py={3}>
          <Button variant="outlined" size="large" fullWidth onClick={handleCancel}>
            <Trans>Cancel</Trans>
          </Button>
          <Button
            variant="contained"
            size="large"
            fullWidth
            onClick={() => handleSave(pageName)}
            disabled={pageName === ""}
          >
            <Trans>Save</Trans>
          </Button>
        </Box>
      </Box>
    </SlidingDrawer>
  );
};

export default AddCustomPageDrawer;
